import { useTranslation } from "react-i18next"
import vconst from "utils/helpers/structs/vconst";
import { useModal } from "context/ModalContext";
import { getButtonsNoYes } from "context/helpers/helperModalContext";
 
const useStatusObject = () => {

    const { t } = useTranslation(['Objects']);
    const { showDlg } = useModal();

    const paramsDelDlg = {
        buttons : [...getButtonsNoYes(t)], 
        type    : 'confirm',
    } 

    const createParams = (type, title, description, objectStatus, cbFunct) => {
        const p = {
            ...paramsDelDlg,
            text: (<>
                <h4 className={`d-flex border-bottom pb-2 mb-2 text-${type}`}>
                <span className="">{title}?</span></h4>
                <span className="">{description}</span> 
            </>)
        }
        p.buttons[1].handleClick = () => {  
            showDlg(false);
            cbFunct({status:objectStatus});
        }

        return p;
    }

    const statusObjectInWork = (cbFunct) => {
        const p = createParams('body ',
                t('toolObjectInWork'),
                t('infoObjectInWork'),
                vconst.objectInWork, cbFunct);  
        showDlg(p)                 
    }

    const statusObjectReturnToTeam = (cbFunct) => {
        const p = createParams('body ',
                t('toolObjectReturnToTeam'),
                t('infoObjectReturnToTeam'),
                vconst.objectInWork, cbFunct);
        showDlg(p)
    }
 
    const statusObjectFinishedTeam = (cbFunct) => {
        const p = createParams('success ',
                t('toolObjectFinishedTeam'),
                t('infoObjectFinishedTeam'),
                vconst.objectFinishedTeam, cbFunct);  
        showDlg(p) 
    }    

    return {
        statusObjectInWork,
        statusObjectReturnToTeam,
        statusObjectFinishedTeam
    }
}

export default useStatusObject;
